import React, { useState, useEffect, useRef } from "react";
import UnderHeader from "./A4/UnderHeader"
import * as _ from "lodash";
import { ButtonBase, Grid } from "@material-ui/core";
import { useInvAF } from "../../../St/Reviews/UseStyle";
import FooterM from "../maintaince/A4/FooterM";
import "../AFReadyDisigen/invoiceprint.css"
import { stylePadding, stylePaddingFooter, stylePaddingHead } from "../ShareFunctionsPrint";
import HeaderCom from "../invCompanyTow/A4/HeaderCom";
import HeaderAll from "../../HeaderAll";
import UnderHeaderCom from "../invCompanyTow/A4/UnderHeaderCom";
import UnderHeaderT from "./A4/UnderHeaderT";
import UnderHeaderComTow from "../invCompanyTow/A4/UnderHeaderComTow";
import BodyCom from "../invCompanyTow/A4/BodyCom";
import BodyInv from "./A4/BodyInv";
import FooterCM from "./A4/FooterCM";
import TotalsCom from "../invCompanyTow/A4/TotalsCom";
import TotalsInvCom from "../AFReadyDisigen/A4/TotalsInvCom";
import InvTotal from "../AFReadyDisigen/A4/InvTotal";
import NewHeadCom from "../NewCompany/NewHeadCom";
import NewUnderCom from "../NewCompany/NewUnderCom";
import NewTotalsCom from "../NewCompany/NewTotalsCom";

function HeadersNew(props) {
    const { locInv, found, sta, inv, page } = props;
    const num = Number(locInv?.largeNum);
    // const num = Number(premiApp.billTemplate);
    return (
        <div style={stylePaddingHead}>
            {[25, 26, 30,33].includes(num) ?
                <HeaderCom found={found} sta={sta} inv={inv} locInv={locInv} /> :
                num === 32 ? <NewHeadCom found={found} sta={sta} inv={inv} locInv={locInv} page={page} /> :
                    <HeaderAll Report={true} found={found} />}
        </div>
    );

}
function HeadersSecond(props) {
    const { locInv, found, sta, inv } = props;
    // const num = Number(premiApp.billTemplate);
    const num = Number(locInv?.largeNum);
    return (
        <div style={stylePadding}>
            {[25, 26, 30,33].includes(num) ? null : num === 27 ?
                <UnderHeaderComTow locInv={locInv} found={found} inv={inv} sta={sta}  /> :
                num === 32 ? <NewUnderCom found={found} inv={inv} sta={sta} locInv={locInv}  /> :
                    <UnderHeaderT found={found} inv={inv} sta={sta} locInv={locInv} />
            }
        </div>
    );
}
function HeadersThird(props) {
    const { locInv, found, sta, inv } = props;
    // const num = Number(premiApp.billTemplate);
    const num = Number(locInv?.largeNum);
    return (
        <div style={stylePadding}>
            {num === 32 ? null : [25, 26, 30,33].includes(num) ?
                (locInv.ProcTypeInvProc !== "22" ? <UnderHeaderCom found={found} inv={inv} sta={sta} locInv={locInv}  /> : null) :
                (locInv.ProcTypeInvProc !== "22" ? <UnderHeader found={found} sta={sta} locInv={locInv}/> : null)
            }
        </div>
    );
}
function BodyInvoice(props) {
    const { locInv, sta, inv, premiApp, chunk, isLast, found } = props;
    // const num = Number(premiApp.billTemplate);
    const num = Number(locInv?.largeNum);

    return (
        <div style={stylePadding}>
            {[25, 26, 30, 32,33].includes(num) ?
                <BodyCom
                    data={chunk ?? []}
                    isLast={isLast}
                    inv={inv}
                    sta={sta}
                    locInv={locInv}
                    found={found}
                    // premiApp={premiApp}
                /> :
                <BodyInv
                    data={chunk ?? []}
                    isLast={isLast}
                    found={found}
                    inv={inv}
                    sta={sta}
                    locInv={locInv}
                    // premiApp={premiApp}
                />
            }
        </div>
    );
}
function NotesFooter(props) {
    const { premiApp, inv, clas } = props;
    const num = Number(premiApp.billTemplate);
    return (
        <div style={stylePadding}>
            {num !== 27 && num !== 32 && num !==30&& num !==33?
                (
                    <Grid item xs={12} className={clas.BdytotCntMmm} style={{ textAlign: "right" }}>
                        {inv.notes}
                    </Grid>
                ) : null}
        </div>
    );
}
function Footers(props) {
    const { found, sta, premiApp, clas } = props;
    const num = Number(premiApp.billTemplate);
    return (
        <div className="footerview" style={stylePaddingFooter}>
            {[25, 26, 30,32].includes(num)  ? null
                : found.footer_img != null ?
                    <Grid container item xs={12} justifyContent="center" style={{ minWidth: "20cm", maxWidth: "20cm", minHeight: "3.9cm", maxHeight: "3.9cm", paddingBottom: "0.2cm", paddingTop: "0.1cm" }}>
                        <div>
                            <ButtonBase>
                                {" "}
                                <img
                                    src={`data:image/jpeg;base64,${found.footer_img}`}
                                    className={clas.headerImg}
                                    alt={found.nameA}
                                />{" "}
                            </ButtonBase>
                        </div>
                    </Grid>
                    : premiApp.billTemplate !== 9 ?
                        <FooterCM found={found} premiApp={premiApp} />
                        :
                        <FooterM found={found} sta={sta ?? {}} premiApp={premiApp} />
            }
        </div>
    );
}


function InvCompanyCon(props) {
    const { locInv, found, sta, inv, data, premiApp } = props;
    const headerFirstRef = useRef(null);
    const headerSecondRef = useRef(null);
    const headerThirdRef = useRef(null);
    const footerRef = useRef(null);
    const totalsRef = useRef(null);
    const footerNotes = useRef(null);
    const clas = useInvAF();
    const numBill=Number(premiApp.billTemplate);
    const rowrefs = useRef([]);
    const [pages, setPages] = useState([]);


    useEffect(() => {
        const calcutepages = async () => {
            if (document.fonts) await document.fonts.ready;
            const PAGE_HEIGHT = 1120;
            const HEADER1 = headerFirstRef.current?.offsetHeight || 0;
            const HEADER2 = headerSecondRef.current?.offsetHeight || 0;
            const HEADER3 = headerThirdRef.current?.offsetHeight || 0;
            const FOOTER1 = footerRef.current?.offsetHeight || 0;
            const totalsH = totalsRef.current?.offsetHeight || 0;
            const FOOTERNOTESREF = footerNotes.current?.offsetHeight || 0;

            const max_HeightFirst = PAGE_HEIGHT - (HEADER1 + HEADER2 + HEADER3 + FOOTER1 + FOOTERNOTESREF + 15);
            const max_HeightOnther = PAGE_HEIGHT - (HEADER1 + HEADER2 + FOOTER1 + FOOTERNOTESREF + 15);
            let maxHightsAll = PAGE_HEIGHT - (HEADER1 + HEADER2 + HEADER3 + FOOTER1 + FOOTERNOTESREF + 15);;
            const heights = rowrefs.current.map(el => el?.offsetHeight || 0);
            let pageInvoice = [];
            let currentPage = [];
            let currentHeight = 0;

            data.forEach((item, i) => {
                const rowHieght = heights[i];
                maxHightsAll = pageInvoice.length === 0 ? max_HeightFirst : max_HeightOnther;
                if (currentHeight + rowHieght > maxHightsAll) {
                    pageInvoice.push(currentPage);
                    currentPage = [];
                    currentHeight = 0;
                }
                currentPage.push(item);
                currentHeight += rowHieght;
            });

            if (currentHeight + totalsH > maxHightsAll) {
                pageInvoice.push(currentPage);
                pageInvoice.push([]);
            } else {
                pageInvoice.push(currentPage);
            }
            setPages(pageInvoice);
        };
        calcutepages();
    }, [data]);


    return (
        <>
            <div className="measurecon" >
                <div ref={headerFirstRef}>
                    <HeadersNew locInv={locInv} found={found} sta={sta} inv={inv} premiApp={premiApp} page={1} />
                </div>
                <div ref={headerSecondRef}>
                    <HeadersSecond locInv={locInv} found={found} sta={sta} inv={inv} premiApp={premiApp} />
                </div>
                <div ref={headerThirdRef}>
                    <HeadersThird locInv={locInv} found={found} sta={sta} inv={inv} premiApp={premiApp} />
                </div>
                {data.map((item, i) => (
                    <div key={i}
                        ref={(el) => (rowrefs.current[i] = el)}
                        className="measurerow"
                    >
                        {item.notesall}
                    </div>
                ))}
                <div ref={footerNotes}>
                    <NotesFooter found={found} inv={inv} premiApp={premiApp} clas={clas} />
                </div>
                <div ref={totalsRef}>
                    {[25,26,30].includes(numBill) ? <TotalsCom found={found} inv={inv} sta={sta} premiApp={premiApp} locInv={locInv}/> :
                    numBill == 27 ?<TotalsInvCom found={found} inv={inv} sta={sta} premiApp={premiApp} /> :
                    numBill===32? <NewTotalsCom found={found} inv={inv} sta={sta} premiApp={premiApp} /> :
                       <InvTotal inv={inv} sta={sta} premiApp={premiApp} />}
                </div>
                <div ref={footerRef}>
                    <Footers found={found} sta={sta ?? {}} premiApp={premiApp} clas={clas} />
                </div>
            </div>

            <div className="invoicepreview">
                {pages.map((page, i) => (
                    <div className="pageinv" key={i}>
                        <div className="contentview">
                            <HeadersNew locInv={locInv} found={found} sta={sta} inv={inv} premiApp={premiApp} page={i + 1} />
                            <HeadersSecond locInv={locInv} found={found} sta={sta} inv={inv} premiApp={premiApp} />
                            {i == 0 && (
                                <HeadersThird locInv={locInv} found={found} sta={sta} inv={inv} premiApp={premiApp} />
                            )}
                            <BodyInvoice locInv={locInv} sta={sta} inv={inv} premiApp={premiApp} chunk={page ?? []} isLast={i == pages.length - 1} found={found} />
                            <NotesFooter found={found} inv={inv} premiApp={premiApp} clas={clas} />
                        </div>
                        <Footers found={found} sta={sta ?? {}} premiApp={premiApp} clas={clas} />
                    </div>
                ))}
            </div>
        </>
    );
}
export default InvCompanyCon;
